import { render, staticRenderFns } from "./VFolderEntry.vue?vue&type=template&id=a4d6b3f8&"
import script from "./VFolderEntry.vue?vue&type=script&lang=ts&"
export * from "./VFolderEntry.vue?vue&type=script&lang=ts&"
import style0 from "./VFolderEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports